.marco {
  border-radius: var(--r-panel);
  border: var(--bw-hair) solid var(--border-hair);
  background: var(--surface-card);
  overflow: hidden;
  overflow-x: auto;
}
.tabla {
  width: 100%;
  min-width: var(--_min, 0);
  border-collapse: collapse;
  font-family: var(--font-body);
}
.tabla[data-fixed] {
  table-layout: fixed;
}
.th {
  padding: var(--s-5) var(--s-7);
  background: var(--surface-sunken);
  border-bottom: var(--bw-hair) solid var(--border-hair);
  font-size: var(--fs-3xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  text-align: left;
  color: var(--text-muted);
  white-space: nowrap;
}
.orden {
  display: inline-flex;
  align-items: center;
  gap: var(--s-2);
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}

.orden:disabled {
  cursor: default;
}

.orden:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.td {
  padding: var(--s-5) var(--s-7);
  border-bottom: var(--bw-hair) solid var(--border-hair);
  font-size: var(--fs-xs);
  color: var(--text-body);
  vertical-align: middle;
  text-align: left;
}
.fila:last-child .td {
  border-bottom: none;
}
.th[data-align="right"],
.td[data-align="right"] {
  text-align: right;
}
.th[data-align="center"],
.td[data-align="center"] {
  text-align: center;
}
.td[data-mono] {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-2xs);
}

/* La fila entera responde al enlace de la primera celda: el `::after` del
   enlace se estira sobre la fila (que es el contexto de posición). Lo que
   tenga que seguir siendo clickeable por su cuenta dentro de la fila
   (un botón, otro enlace) se pone por encima con `position: relative`. */
.fila {
  position: relative;
  transition: background var(--dur-fast) var(--ease-standard);
}
.fila[data-interactive] {
  cursor: pointer;
}
.fila[data-highlight="brand"] {
  background: var(--surface-brand-tint);
}
.fila[data-highlight="muted"] {
  background: var(--surface-tint);
}
.fila[data-highlight="warning"] {
  background: var(--status-warning-bg);
}
.enlaceFila {
  color: inherit;
  text-decoration: none;
  border-bottom: 0;
}
.enlaceFila::after {
  content: "";
  position: absolute;
  inset: 0;
}
.fila .td > :is(button, a:not(.enlaceFila)) {
  position: relative;
  z-index: 1;
}
@media (hover: hover) {
  .fila[data-interactive]:hover {
    background: var(--surface-sunken);
  }
}
.fila:focus-visible,
.fila:has(.enlaceFila:focus-visible) {
  outline: none;
  box-shadow: inset var(--ring-focus);
  background: var(--surface-sunken);
}
.enlaceFila:focus-visible {
  outline: none;
  box-shadow: none;
}

.fantasma {
  display: block;
  height: var(--s-6);
  border-radius: var(--r-xs);
  background: var(--surface-muted);
  animation: latir var(--dur-slower) var(--ease-standard) infinite alternate;
}
@keyframes latir {
  to {
    opacity: 0.55;
  }
}

.vacio {
  padding: var(--s-9);
  text-align: center;
  color: var(--text-muted);
  font-size: var(--fs-sm);
}
.paginado {
  padding: var(--s-5) var(--s-7);
  border-top: var(--bw-hair) solid var(--border-hair);
}

/* Adentro de una Card (`variant="flush"`): sin marco propio, la cabecera en sentence case con regla arriba,
   24px contra los bordes de la tarjeta, cifras en tinta y hover en todas las filas. */
.marco[data-variant="flush"] {
  border: none;
  border-radius: 0;
  background: transparent;
}
.marco[data-variant="flush"] .th {
  padding: var(--s-5) var(--s-6);
  border-top: var(--bw-hair) solid var(--border-hair);
  font-size: var(--fs-2xs);
  letter-spacing: 0;
  text-transform: none;
}
.marco[data-variant="flush"] .td {
  padding: var(--s-5) var(--s-6);
}
.marco[data-variant="flush"] :is(.th, .td):first-child {
  padding-left: var(--s-8);
}
.marco[data-variant="flush"] :is(.th, .td):last-child {
  padding-right: var(--s-8);
}
.marco[data-variant="flush"] .td[data-mono] {
  color: var(--text-strong);
}
.marco[data-variant="flush"] .vacio {
  padding: var(--s-11) var(--s-8);
  font-size: var(--fs-xs);
}
.marco[data-variant="flush"] .paginado {
  padding-inline: var(--s-8);
}
@media (hover: hover) {
  .marco[data-variant="flush"] .fila:hover {
    background: var(--surface-sunken);
  }
}

@media (max-width: 767px) {
  .th[data-hide="md"],
  .td[data-hide="md"] {
    display: none;
  }
  /* Con `table-layout: fixed` el ancho lo fija la `<col>`: si no se va también, la columna oculta sigue ocupando lugar. */
  .tabla col[data-hide="md"] {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .fila {
    transition: none;
  }
  .fantasma {
    animation: none;
  }
}
